import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Column, Row } from '~/commonComponents';
import { WarningSolidIcon } from '~/images/icons';

interface IInfoSectionProps {
  title: string;
  value: string | number | undefined;
  showWarningIcon?: boolean;
}

export const InfoSection = ({ title, value, showWarningIcon = false }: IInfoSectionProps) => (
  <Column gap={4}>
    <Row alignItems="center" gap={8}>
      <Typography as="span" bold size="heading_4">
        {title}:
      </Typography>
      {showWarningIcon && <WarningSolidIcon color={colors.warning[500]} size={18} />}
    </Row>
    <Typography as="span">{value}</Typography>
  </Column>
);
